import React, { useState, useEffect } from 'react';
import validIcon from "../../assets/images/register/green_check.svg";
import editIcon from '../../assets/images/register/edit.png';
import ReactGA from "react-ga";
import Cookies from "universal-cookie";
import { useSelector } from 'react-redux';
import useWebOtpAutofill from "../../utils/useWebOtpAutofill";

const CareersRegisterInputOtp = (props) => {
  const cookies = new Cookies();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const [focused, setFocused] = useState(false);
  const { loginData, loginDataLoading, userLoginSignupOtp, userLoginSignupOtpError } = useSelector((state) => state.usersCommonData)
  const { otpVerifyCheck, otpVerifyLoading,  otpVerifyError} = useSelector((state) => state.usersGoogleSiginIn)
  const isProfileCheck = window.location.pathname?.includes("user/complete-profile") || window.location.pathname?.includes("user/update-profile");

  useEffect(() => {
    if(isProfileCheck){
    setFocused(true);
    }
    props.setRemainingSeconds(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0))
  }, [])

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (props.remainingSeconds > 0) {
        props.setRemainingSeconds(prevSeconds => prevSeconds - 1);
      } else {
        clearInterval(countdownInterval);
      }
    }, 1000);
    if (props.remainingSeconds < 3) {
      localStorage.removeItem("remainingSeconds");
    }
    return () => clearInterval(countdownInterval);
  }, [props.remainingSeconds])

  useEffect(() => {
    if (loginDataLoading) {
      setError(null)
    } else if (loginData?.otp_response == false && props.values.otp?.length == 4 && loginData?.otp_on) {
      setError(loginData?.message)
    }
    if (isProfileCheck && otpVerifyLoading) {
      setError(null)
    } else if (otpVerifyError?.otp_response == false && props.values.otp?.length == 4 && otpVerifyError?.otp_on) {
      setError(otpVerifyError?.message)
    }
  }, [loginData, loginDataLoading, otpVerifyError, otpVerifyLoading])
  
  useEffect(() => {
    if (isProfileCheck && otp?.length == 4) props.otpSubmitMobile();
  }, [otp])

  useEffect(() => {
      if(isProfileCheck && !props.values.otp){
        setOtp("");
        setError(null);
      }
  }, [props.values.otp])

  // Auto-detect OTP via WebOTP API (SMS autofill without user tapping a suggestion).
  // Feeds both the local `otp` state (triggers the complete-profile/update-profile auto-submit
  // effect above) and setFieldValue/setFormikValues (triggers signup's own formikValues.otp-based
  // auto-submit in CareersRegisterOtpVerifyScreen.js) - so every flow's existing submit trigger
  // fires the same way it would for manual entry, instead of duplicating a direct submit call here.
  const restartOtpAutofill = useWebOtpAutofill((code) => {
    props.setFieldValue("otp", code);
    setOtp(code);
    props.setFormikValues?.((prev) => ({ ...prev, "otp": code }));
  }, "(signup)");

  const handleResendClick = () => {
    restartOtpAutofill();
    setOtp("");
    setError(null);
    props.setFormikValues((prev) => ({...prev, "otp": ""}));
    props.setReinitialize(true)
    setTimeout(() => props.setReinitialize(false), 50);
  };

  const handleChange = (e) => {
    const sanitizedValue = e.target.value?.replace(/[^\d]/g, '');
    props.setFieldValue("otp", sanitizedValue);
    setOtp(sanitizedValue);
  };
  return (
    <>
    {(isProfileCheck ? ((userLoginSignupOtp || userLoginSignupOtpError?.block_user_case == "try_again") && !otpVerifyCheck) : true) &&
        <div className={error || (loginData?.otp_response == false && otp?.length == 4) ? "careers_register_form_card invalid_field multi_check_padding" : otp ? "careers_register_form_card white_bg multi_check_padding" : "careers_register_form_card multi_check_padding"}>

          <div className="otp_field_input">
            <input
              type="text"
              name={props.name}
              className="input_type_text"
              value={otp}
              inputMode="numeric"
              pattern="\d{4}"
              autoComplete="one-time-code"
              maxLength={4}
              onChange={(e) => {
                handleChange(e)
              }}
              autoFocus= {isProfileCheck ? true : false}
              onFocus={() => {
                setFocused(true)
              }}
              onBlur={() => { setFocused(false) }}
              required />
          </div>
          <span className={focused || otp ? "floating_label_active" : "floating_label"}>
            {isProfileCheck ? <>Enter OTP</> : <>Please enter OTP</>}
          </span>
          {/* Resend OTP */}
          {props.remainingSeconds ? (
            <div className="resend_otp resend_otp_disabled">
              <span className='resend_otp_deactivate'>Resend OTP in</span>
              <span className='resend_otp_time'>
                <span>{`${props.remainingSeconds % 60}`}</span> sec
              </span>
            </div>
          ) : (
            <div onClick={() => { handleResendClick(); props.otpGetClicked(); props.resetTimer() }} className="resend_otp">
              <span className='resend_otp_active'>Resend OTP</span>
            </div>
          )}

          {/* Invalid Card */}
          {error &&
            <div className="invalid_card">
              <span className="invalid_card_text">{error}</span>
            </div>}
        </div>
    }
    </>
  )
}

export default CareersRegisterInputOtp;